import React from 'react'
// c:\xampp\htdocs\miners-market-main\components\QuoteConfirmationModal.js

export default function QuoteConfirmationModal({ isOpen, onClose, userEmail, onConfirm }) {
    const [email, setEmail] = React.useState(userEmail);
    const [useAlternative, setUseAlternative] = React.useState(false);
    const [isProcessing, setIsProcessing] = React.useState(false);
    const [error, setError] = React.useState(null);

    React.useEffect(() => {
        if (isOpen) {
            setEmail(userEmail);
            setUseAlternative(false); // Only reset when modal opens
            setIsProcessing(false);
            setError(null);
        }
    }, [isOpen]); // Only depend on isOpen, not userEmail

    if (!isOpen) return null;

    const handleConfirm = async () => {
        setIsProcessing(true);
        setError(null);
        try {
            // The onConfirm function will handle the PDF generation and API call.
            // We just pass the final email address to it.
            await onConfirm(email);
            // The parent component will close the modal on success.
        } catch (err) {
            setError(err.message);
            setIsProcessing(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl p-8 max-w-md w-full">
                <h2 className="text-xl font-bold text-gray-900 mb-4">Confirm Your Email</h2>
                
                {!useAlternative ? (
                    <div>
                        <p className="text-gray-600 mb-4">The quote will be sent to this email address:</p>
                        <p className="font-semibold text-blue-600 bg-gray-100 p-3 rounded-lg mb-6">{email}</p>
                        <div className="flex justify-between items-center">
                            <button onClick={(e) => { e.stopPropagation(); setUseAlternative(true); }} className="text-sm text-blue-600 hover:underline">Use a different email</button>
                            <div className="flex space-x-4">
                                <button onClick={(e) => { e.stopPropagation(); onClose(); }} className="bg-gray-200 text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-300">Cancel</button>
                                <button onClick={(e) => { e.stopPropagation(); handleConfirm(); }} disabled={isProcessing} className="primary-gradient text-white py-2 px-4 rounded-lg hover:opacity-90 disabled:opacity-50">
                                    {isProcessing ? 'Sending...' : 'Yes, Send Quote'}
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        <p className="text-gray-600 mb-4">Please enter the email address where you would like to receive the quote:</p>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            onFocus={(e) => e.stopPropagation()}
                            className="w-full border-gray-300 rounded-md shadow-sm mb-6"
                            placeholder="Enter alternative email"
                        />
                        <div className="flex justify-end space-x-4">
                            <button onClick={(e) => { e.stopPropagation(); setUseAlternative(false); setEmail(userEmail); }} className="text-sm text-gray-600 hover:underline">Use my profile email</button>
                            <button onClick={(e) => { e.stopPropagation(); handleConfirm(); }} disabled={isProcessing} className="primary-gradient text-white py-2 px-4 rounded-lg hover:opacity-90 disabled:opacity-50">
                                {isProcessing ? 'Sending...' : 'Send Quote'}
                            </button>
                        </div>
                    </div>
                )}

                {error && (
                    <div className="mt-4 text-red-500 text-sm p-3 bg-red-100 rounded-md">
                        {error}
                    </div>
                )}
            </div>
        </div>
    );
}
